export default {
    required: 'Pole marka jest wymagane',
    pattern: {
        value: /.{2,}/,
        message: 'Wybierz poprawną markę z listy'
    }
}